import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { socketSetup } from "../../library/socket-io/socket-setup";
import { proposalAPI } from "../../api/gms/proposal/proposal-api";
import { proposalChatsAPI } from "../../api/gms/proposal-chat/proposal-chats-api";

export const useMessagesSocket = () => {
    const dispatch = useDispatch();

    const invalidateCategory = useCallback(() => {
        // const invalidate = () => {
            dispatch(
                proposalChatsAPI.util.invalidateTags([
                    { type: "ProposalChats", id: "LIST" },
                ])
            );

            dispatch(
                proposalAPI.util.invalidateTags([
                    { type: "Proposal", id: "LIST" },
                ])
            );
        // };
    }, [dispatch])

    useEffect(() => {
        if(!socketSetup) return;
        
        socketSetup.on("addNewComment", invalidateCategory);
        socketSetup.on("updateComment", invalidateCategory);
        socketSetup.on("deletedComment", invalidateCategory);

        return () => {
            socketSetup.off("addNewComment", invalidateCategory);
            socketSetup.off("updateComment", invalidateCategory);
            socketSetup.off("deletedComment", invalidateCategory);
        };
    }, [invalidateCategory])
}